// index.tsx
import React from "react";
import {createRoot} from "react-dom/client";
import {BrowserRouter as Router} from "react-router-dom";

import ErrorBoundary from "components/ErrorBoundary";
import App from "./App";

// Global handlers remain outside React tree:
// window.addEventListener("error", event => {
//     notifySlack(`*Global Error:* ${event.message}\n*Source:* ${event.filename}:${event.lineno}`);
// });
// window.addEventListener("unhandledrejection", event => {
//     notifySlack(`*Unhandled Promise Rejection:* ${event.reason}`);
// });

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
	<Router>
		<ErrorBoundary>
			<App />
		</ErrorBoundary>
	</Router>,
);
